import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Content = {
  __typename?: 'Content';
  definition: Scalars['JSON']['output'];
};

export enum ContentType {
  EndingPage = 'ENDING_PAGE',
  LandingPage = 'LANDING_PAGE',
  PresignupText = 'PRESIGNUP_TEXT'
}

export type Organisation = {
  __typename?: 'Organisation';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationContent: Array<OrganisationContent>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type OrganisationContent = {
  __typename?: 'OrganisationContent';
  content: Content;
  contentType: ContentType;
};

export type Query = {
  __typename?: 'Query';
  getReferralInvite?: Maybe<ReferralInvite>;
  getReferralInviteContent?: Maybe<OrganisationContent>;
};


export type QueryGetReferralInviteArgs = {
  invitePublicId: Scalars['String']['input'];
};


export type QueryGetReferralInviteContentArgs = {
  contentType: ContentType;
  invitePublicId: Scalars['String']['input'];
};

export type Referral = {
  __typename?: 'Referral';
  contact?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  eprId?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  service?: Maybe<Service>;
  status: ReferralStatus;
};

export type ReferralInvite = {
  __typename?: 'ReferralInvite';
  authSystemId?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  publicId: Scalars['String']['output'];
  referralSession: ReferralSession;
  reviewEnabled?: Maybe<Scalars['Boolean']['output']>;
  status: ReferralInviteStatus;
};

export enum ReferralInviteStatus {
  Completed = 'completed',
  Pending = 'pending'
}

export type ReferralSession = {
  __typename?: 'ReferralSession';
  referral: Referral;
  status: ReferralSessionStatus;
};

export enum ReferralSessionStatus {
  Completed = 'completed',
  Expired = 'expired',
  Pending = 'pending'
}

export enum ReferralStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Pending = 'pending'
}

export type Service = {
  __typename?: 'Service';
  code: Scalars['String']['output'];
};

export type GetReferralInviteQueryVariables = Exact<{
  invitePublicId: Scalars['String']['input'];
}>;


export type GetReferralInviteQuery = { __typename?: 'Query', getReferralInvite?: { __typename?: 'ReferralInvite', id: string, publicId: string, authSystemId?: string | null, givenName?: string | null, reviewEnabled?: boolean | null, status: ReferralInviteStatus, referralSession: { __typename?: 'ReferralSession', status: ReferralSessionStatus, referral: { __typename?: 'Referral', status: ReferralStatus, contact?: string | null, organisation?: { __typename?: 'Organisation', name?: string | null, code?: string | null, shortName?: string | null, privacyPolicyUrl?: string | null, organisationContent: Array<{ __typename?: 'OrganisationContent', contentType: ContentType, content: { __typename?: 'Content', definition: any } }> } | null, service?: { __typename?: 'Service', code: string } | null } } } | null };

export type GetReferralInviteContentQueryVariables = Exact<{
  contentType: ContentType;
  invitePublicId: Scalars['String']['input'];
}>;


export type GetReferralInviteContentQuery = { __typename?: 'Query', getReferralInviteContent?: { __typename?: 'OrganisationContent', contentType: ContentType, content: { __typename?: 'Content', definition: any } } | null };


export const GetReferralInviteDocument = gql`
    query GetReferralInvite($invitePublicId: String!) {
  getReferralInvite(invitePublicId: $invitePublicId) {
    id
    publicId
    authSystemId
    givenName
    reviewEnabled
    status
    referralSession {
      status
      referral {
        organisation {
          name
          code
          organisationContent {
            contentType
            content {
              definition
            }
          }
          shortName
          privacyPolicyUrl
        }
        service {
          code
        }
        status
        contact
      }
    }
    status
  }
}
    `;

export function useGetReferralInviteQuery(options: Omit<Urql.UseQueryArgs<GetReferralInviteQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReferralInviteQuery, GetReferralInviteQueryVariables>({ query: GetReferralInviteDocument, ...options });
};
export const GetReferralInviteContentDocument = gql`
    query getReferralInviteContent($contentType: ContentType!, $invitePublicId: String!) {
  getReferralInviteContent(
    contentType: $contentType
    invitePublicId: $invitePublicId
  ) {
    contentType
    content {
      definition
    }
  }
}
    `;

export function useGetReferralInviteContentQuery(options: Omit<Urql.UseQueryArgs<GetReferralInviteContentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReferralInviteContentQuery, GetReferralInviteContentQueryVariables>({ query: GetReferralInviteContentDocument, ...options });
};